
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#F4F4F4","stroke":"#4D4D4D","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M24.333 8c-2.778 4.276-6.974 7-11.666 7S3.769 12.276 1 8c2.769-4.276 6.975-7 11.667-7s8.898 2.724 11.666 7z"}}),_c('path',{attrs:{"d":"M12.668 11.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"}})])])
          )
        }
      }
    